import {
  ActivityIcon,
  ArrowLeftRightIcon,
  BoxesIcon,
  CpuIcon,
  KeyRoundIcon,
  LayoutDashboardIcon,
  LibraryIcon,
  type LucideIcon,
  MapPinIcon,
  ScanLineIcon,
  ShoppingCartIcon,
  SlidersHorizontalIcon,
  TagsIcon,
} from 'lucide-react'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  /** Shown in the phone's bottom bar. */
  primary?: boolean
}

export interface NavGroup {
  label: string
  items: NavItem[]
}

export const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Inventory',
    items: [
      { to: '/', label: 'Overview', icon: LayoutDashboardIcon, primary: true },
      { to: '/parts', label: 'Parts', icon: CpuIcon, primary: true },
      { to: '/locations', label: 'Storage', icon: MapPinIcon, primary: true },
      { to: '/projects', label: 'Projects', icon: BoxesIcon },
    ],
  },
  {
    label: 'Tools',
    items: [
      { to: '/scan', label: 'Scan', icon: ScanLineIcon, primary: true },
      { to: '/labels', label: 'Labels', icon: TagsIcon },
      { to: '/providers', label: 'Distributors', icon: ShoppingCartIcon },
      { to: '/import-export', label: 'Exchange', icon: ArrowLeftRightIcon },
      { to: '/activity', label: 'Activity', icon: ActivityIcon },
    ],
  },
  {
    label: 'Setup',
    items: [
      { to: '/catalogue', label: 'Catalogue', icon: LibraryIcon },
      { to: '/settings', label: 'Passkeys & tokens', icon: KeyRoundIcon },
      { to: '/preferences', label: 'Preferences', icon: SlidersHorizontalIcon },
    ],
  },
]

/** The destinations in the phone's bottom bar, in order. */
export const PRIMARY_NAV = NAV_GROUPS.flatMap((group) => group.items).filter((item) => item.primary)
